'use strict';

angular.module('sharedModule', []);
